import { useEffect, useState } from "react";
import { useBookingContext } from "../../context/BookingContext";
import { Box, Button, Grid, GridItem, Text } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import {
  BookCard,
  BookCardTitle,
  BookCardSubtitle,
} from "../../components/Book/BookCard";

import { BookSlotCard } from "../../components/Book/BookSlotCard";
import { BaseUnfold } from "../../components/Base/BaseUnfold";

const SelectSlotPage = () => {
  const history = useHistory();
  const { stepr } = useBookingContext();
  const [selectedClass, setSelectedClass] = useState(-1);

  useEffect(() => {
    stepr.setStep(3);
  }, [stepr]);

  const handleClickContinue = () => {
    /**
     * TODO: validate form
     */
    stepr.nextStep();
    history.push("/book/confirm");
  };

  return (
    <BookCard mt={"10px"} mx="auto">
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box>
          <BookCardTitle small>Start Date</BookCardTitle>
          <BookCardSubtitle small>
            Please choose class start date
          </BookCardSubtitle>
        </Box>

        <Box color="#797979" fontSize={"20px"}>
          <i className="ri-information-fill"></i>
        </Box>
      </Box>

      <Box mt="3">
        <BookSlotCard selected />
      </Box>

      <Box mt={3}>
        <Text
          color={"#A5A5A5"}
          fontSize={"16px"}
          lineHeight={"21px"}
          fontFamily={"Open Sans"}
        >
          Other slots
        </Text>

        <Grid
          mt={3}
          gap={"10px"}
          templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(3, 1fr)" }}
        >
          {[...new Array(12).keys()].map((index) => (
            <GridItem w="100%" key={index}>
              <BookSlotCard
                selected={selectedClass === index}
                onClick={() => setSelectedClass(index)}
              />
            </GridItem>
          ))}
        </Grid>

        <Box mt="3" textAlign="center">
          <button>
            <Text
              color={"#27489B"}
              fontSize="sm"
              fontWeight="700"
              fontFamily="Cairo"
              lineHeight="20px"
            >
              Load More
            </Text>
          </button>
        </Box>

        <BaseUnfold
          activator={({ folded, onClick }) => (
            <Box
              role={"button"}
              display="flex"
              alignItems="center"
              experimental_spaceX={3}
              onClick={onClick}
            >
              <Text color="#506BAE">Class Description</Text>
              <i
                className="ri-arrow-down-s-line"
                style={{
                  color: "#9CA3AF",
                  fontSize: "18px",
                  transition: "all 0.3s ease-in-out",
                  transform: folded ? "rotate(0deg)" : "rotate(180deg)",
                }}
              ></i>
            </Box>
          )}
        >
          <Box
            mt="3"
            color="#52525B"
            fontSize="16px"
            fontWeight="400"
            lineHeight="21.79px"
            fontFamily="Open Sans"
          >
            <Text>
              In today's world, technology is king if you want your child to
              have a successful future, they need to stay ahead of the curve
              with real-life, hands-on skills. They'll learn more about how
              computers work, while dreaming up unique projects, learning
              resilience and discipline, and working in an empowering group
              setting. In the MakerKids Coding Program for kids, your child will
              code games, websites and more! In our coding classes children
              learn how computers work, exercise creativity by coming up with
              ideas for how their project will look and feel, and build
              resilience and perseverance when trouble-shooting their very own
              game.
            </Text>
            <Text mt="2">
              Start anytime! A new project each week, allowing kids to join
              anytime. Projects combine foundational building blocks with new
              material, which teaches and reinforces concepts in new ways to
              learn by doing through project-based learning. After you sign up,
              you will be invited to book an onboarding call prior to your first
              class to help ensure you are all set up.
            </Text>
          </Box>
        </BaseUnfold>

        <Button
          colorScheme={"blue"}
          display={"block"}
          width={"full"}
          rounded="12px"
          h={"44px"}
          fontSize={"sm"}
          fontFamily="Cairo"
          border={"none"}
          mt="3"
          boxShadow={"0px 1px 2px rgba(31, 41, 55, 0.08)"}
          onClick={handleClickContinue}
        >
          Continue
        </Button>
      </Box>
    </BookCard>
  );
};

export { SelectSlotPage };
